module.exports = __webpack_public_path__ + "static/media/ShardMeetingRoom11.0fe46cfb.jpg";